/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Presence_NInputs */

const en_tut_presence_n = /** @type {(inputs: Tut_Presence_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesian public holidays and collective leave days are already taken into account, so nobody waits for an answer on a day that is genuinely a holiday. Only you can set your own status.`)
};

const id_tut_presence_n = /** @type {(inputs: Tut_Presence_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hari libur nasional dan cuti bersama Indonesia sudah diperhitungkan, jadi rekan tidak menunggu jawaban di hari yang memang libur. Status hanya bisa diatur oleh pemiliknya sendiri.`)
};

/**
* | output |
* | --- |
* | "Indonesian public holidays and collective leave days are already taken into account, so nobody waits for an answer on a day that is genuinely a holiday. Only..." |
*
* @param {Tut_Presence_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_presence_n = /** @type {((inputs?: Tut_Presence_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Presence_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_presence_n(inputs)
	return en_tut_presence_n(inputs)
});